"use strict";

exports.__esModule = true;
exports.default = void 0;

var _utils = require("@material-ui/core/utils");

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 3.75c-4.549 0-8.25 3.701-8.25 8.25s3.701 8.25 8.25 8.25c4.549 0 8.25-3.701 8.25-8.25S16.549 3.75 12 3.75zm0 15.469c-3.98 0-7.219-3.238-7.219-7.219S8.02 4.781 12 4.781c3.98 0 7.219 3.238 7.219 7.219S15.98 19.219 12 19.219zm2.578-9.549a2.582 2.582 0 0 1-2.063 2.526v1.351a.516.516 0 1 1-1.032 0v-1.815c0-.285.231-.516.516-.516.853 0 1.547-.694 1.547-1.547s-.694-1.547-1.547-1.547-1.547.694-1.547 1.547a.516.516 0 1 1-1.032 0c0-1.421 1.156-2.578 2.578-2.578s2.578 1.157 2.578 2.578zm-1.96 6.105a.617.617 0 1 1-1.234.002.617.617 0 0 1 1.234-.002z"
}), 'RoundQuestion');

exports.default = _default;